import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { JaaRoute } from '../../utilities/Links';
import { Link as RouterLink } from 'react-router';

export const NoResults: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        paddingLeft: 2,
      }}
    >
      <Typography
        variant='h2'
        sx={{
          paddingBottom: 2,
        }}
      >
        {t('search.content.noResults.title')}
      </Typography>
      <Typography
        variant='body1'
        sx={{
          paddingBottom: 2,
        }}
      >
        {t('search.content.noResults.noMatchingResultsHelper')}
      </Typography>
      <Typography variant='body1'>
        Haku toimii toistaiseksi vain sisältöjen otsikkotietoihin, joten se ei
        välttämättä vielä löydä kaikkia sisältöjä. Voit myös selata sisältöjä{' '}
        <Link to={JaaRoute.authorListPage} component={RouterLink}>
          tekijän
        </Link>{' '}
        mukaan.
      </Typography>
    </Box>
  );
};
